/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import _, { isNil, get, isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import currentUserStorage from 'containers/services/security/current-user-storage';
import {
  Container,
  SahamTabsGlobal,
  StyledTopDiv,
} from 'containers/CourtManagerLegalProceedings/styled-components';
import ClaimRecap from 'containers/LawyerRecapPage/LawyerRecap';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import GlobalLegalProceedingTabs from 'components/GlobalLegalProceedingTabs';
import {
  makeSelectCurrentInstanceTab,
  makeSelectLinkToBeneficiaryCodes,
  makeSelectListings,
  makeSelectNotificationsInboxes,
} from 'containers/AppContainer/selectors';
import {
  makeSelecClaimRecap,
  makeSelectCorporealExperts,
} from 'containers/RecapManagerPage/selectors';
import {
  requestAssigment,
  requestClaimRecap,
  requestUpdateVictimInfo,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  resetStoreClaim,
} from 'containers/RecapManagerPage/actions';
import { requestUpdateFeeNoteAmount } from 'containers/LawyerFeeNote/actions';
import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import {
  makeSelectExpertiseRaport,
  makeSelectJudgementAdd,
  makeSelectJudgementOnMerits,
  makeSelectJudgementAppeal,
  makeSelectDahirAmounts,
  makeSelectDahirAmountsCorpo,
  makeSelectJudgementOnMeritsAppeal,
  makeSelectExpertiseRaportAppeal,
  makeSelectJudgementAddAppeal,
  makeSelectJudgementOnMeritsMultiple,
  makeSelectAppealOnMeritsMultiple,
} from 'containers/LawyerLegalProceedingsPage/selectors';
import {
  requestGetJudgementAdd,
  requestGetDahirAmount,
  requestCreateJudgementOnMeritsContestation,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  requestGetJudgementAddAppeal,
  updateContestation,
  requestUploadContestationDocument,
  requestGetJudgementOnMeritsMultiple,
  requestGetAppealOnMeritsMultiple,
  requestCreateJudgementAdd,
  requestUpdateJudgementAdd,
  setLockedClaim,
  resetLegalProceeding,
  requestAddJudgementOnMeritsSupportDocument,
} from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestCheckCivilPartyJudiciaryProcess,
  requestGetClaimHistoryActions,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestResetHistoryStore,
  requestSetPriorityClaimProvision,
  requestUploadDocumentManager,
} from 'containers/CourtManagerLegalProceedings/actions';
import {
  makeSelectCheckCivilPartyJudiciaryProcess,
  makeSelectClaimHistoryActions,
  makeSelectClaimHistorySagis,
} from 'containers/CourtManagerLegalProceedings/selectors';
import {
  extractUpdatedDocument,
  filterVehicle,
  filterVictim,
  getCourtFileNumber,
  isBlockStatusClaim,
  isLockedClaim,
} from 'containers/CourtManagerLegalProceedings/utils';
import {
  requestMakeJudgementAddDecision,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestValidateJudgementAppeal,
  requestCreateCivilProceeding,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestMakeJudgementAddDocumentDecision,
  requestAddVictims,
  requestAddVehicles,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestGetExpertUsers,
  requestUpdateCivilProceeding,
  requestUnlockClaim,
  requestLockClaim,
} from 'containers/CourtManagerLegalProceedings/actions';
import {
  IAppealPayload,
  ICurrentSteps,
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { getLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/actions';
import { makeSelectLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/selectors';
import {
  requestGetExpertiseRaport,
  requestGetJudgementOnMerits,
  requestGetJudgementAppeal,
  requestGetDahirAmountCorpo,
} from 'containers/LawyerLegalProceedingsPage/actions';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
  requestGetReportsPolicy,
} from 'containers/UploadDocuments/actions';
import {
  requestCreateFeeNote,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
} from 'containers/LawyerFeeNote/actions';
import {
  requestManagerFeeNotes,
  requestFeeNoteExceptionalCosts,
  requestCreateFeeNoteManager,
} from 'containers/ManagerFeeNote/actions';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import {
  makeSelectCountFeeNotes,
  makeSelectFeeNotes,
  makeSelectAllFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import { makeSelectCivilProceeding } from 'containers/LawyerLegalProceedingsPage/selectors';
import { requestCreateJudgementOnMerits } from 'containers/LawyerLegalProceedingsPage/actions';
import { priorityClaimReason } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { PAGES } from 'routes';
import routesHelper from 'containers/services/routes-helper';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import DialogFeeNote from 'components/DialogFeeNote';
import {
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
} from 'containers/ManagerFeeNote/actions';
import {
  requestAddTransaction,
  requestGetTransaction,
  requestUpdateTransaction,
  requestAddContactTransaction,
  requestGetContactTransaction,
  resetStoreTransaction,
  requestUpdateContactTransaction,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
  requestUpdateMissionTransaction,
  requestGetFeeNotesTransaction,
} from 'containers/TransactionManagerTimeLine/actions';
import { makeDecisionFeeNote } from 'containers/ManagerFeeNote/actions';
import { requestGetCivilProceeding } from 'containers/LawyerLegalProceedingsPage/actions';
import { setCurrentInstanceTab } from 'containers/AppContainer/actions';
import DialogCivilProceeding from 'components/DialogCivilProceeding';
import CivilProceedingForm from 'containers/CourtManagerLegalProceedings/civilProceeding';
import { makeSelectCorporealLawyers } from 'containers/RecapManagerPage/selectors';
import ManagerLegalProceedingsPage from 'containers/CourtMonitoringManagerLegalProccedings/LegalProcceding';
import AssignExpertDrawer from 'containers/CourtManagerLegalProceedings/AssignExpert/DrawerExpert';
import DialogDisclaimerWarranty from 'components/DialogDisclaimerWarranty';
import {
  requestSagisClaimInfo,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  resetSagisInfoClaim,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  makeSelectSagisClaim,
  makeSelectJudgementOnMeritsByVictims,
  makeSelectJudgementOnMeritsByVehicles,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import { DamageType } from 'containers/CourtManagerLegalProceedings/typings';
import {
  CLAIM_TYPE_INIT_STATE,
  DAMAGE_INIT_STATE,
  OTHER_DAMAGE_INIT_STATE,
  OTHER_PROPERTIES_DESCRIPTION_SIZE_LIMIT,
  PROVISION_TAB_LABELS,
  rcCoporeal,
  VEHICLE_FORM_INIT_STATE,
  VEHICLE_FORM_VALUES_INIT_STATE,
  VICTIM_FORM_INIT_STATE,
  VICTIM_FORM_VALUES_INIT_STATE,
} from 'containers/CourtManagerLegalProceedings/constants';
import { VehicleForm } from 'containers/CourtManagerLegalProceedings/typings';
import {
  getRiskIdFromPolicyInfo,
  formatOpposingParties,
  claimTabs,
} from 'containers/CourtManagerLegalProceedings/utils';
import { TopCard } from 'containers/CourtManagerLegalProceedings/TopCard';
import JudiciaryProcessTabs from 'components/JudiciaryProcessTabs';
import {
  CIVIL_PROCEEDING_INFORMATIONS_FIELDS,
  LISTINGS,
  VICTIM,
} from 'containers/data-structure';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { ALL_STATUS } from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/constants';
import AssignmentClaimDrawer from 'components/AssignmentClaimDrawer';
import AssignmentDialog from 'containers/RecapManagerPage/AssignmentDialog';
import VictimFormComponent from 'containers/CourtManagerLegalProceedings/VictimFormComponent';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import {
  makeSelectCurrentTabManager,
  makeSelectGlobalCurrentTabManager,
  makeSelectCurrentTabJudiciaryProcessManager,
} from 'containers/AppContainer/selectors';
import * as util from 'containers/RecapManagerPage/utils';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import ProvisionContainer from 'containers/CourtManagerLegalProceedings/Provision';
import ExpertiseExpert from 'containers/CourtManagerLegalProceedings/ExpertiseExpert';
import { requestGetExpertiseVictim } from 'containers/ExpertExpertise/actions';
import {
  makeSelectResultSearchQuery,
  makeSelectSearchQuery,
} from 'containers/ManagerHomePage/selectors';
import { getAssignedJurisdictionLawyerCode } from 'containers/RecapManagerPage/utils';
import {
  resolveSagisClaim,
  shouldShowVictimExcludedWarning,
} from 'helpers/utils';
import { makeSelectVictimExpertise } from 'containers/ExpertExpertise/selectors';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import SuspiciousCard from 'containers/CourtManagerLegalProceedings/SuspiciousCard';
import {
  extractOpposingParties,
  victimValidator,
} from 'containers/PreOpeningPage/utils';
import ImagineDocumentsDrawer from 'containers/CourtManagerLegalProceedings/ImagineDocuments';
import TrackingActionDrawer from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer';
import {
  formatCourtFileNumber,
  validationCourtFileNumber,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import Transaction from 'containers/TransactionManagerTimeLine/Transaction/index';
import WarningCard from 'containers/common/Card/WarningCard';
import { PROFESSION_CODES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  addPriorityReasonProfession,
  removeWhiteSpaceFromString,
  validationVehicle,
} from 'services/utils';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import { requestGetJudgements } from 'containers/common/LegalProceedings/actions';
import { GLOBAL_STATUS, OPENING_STATE } from 'services/constants';
import { VictimType } from 'typings/globalTypes';
import { ClaimRecapType } from 'typings/claimTypes';
import { Claim } from 'containers/PreOpeningPage/typings';
import { formsAreValidated } from 'containers/services/validateForm';

export interface CourtManagerLegalProceedingsPageProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  requestClaimRecap: Function;
  getLegalProceedingsSteps: Function;
  claimRecap: ClaimRecapType;
  currentSteps: ICurrentSteps[];
  policyInfo: { sagis: { claims: any } };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  match: { params: { claimId: number } };
  requestGetJudgementAdd: Function;
  judgementAdd: IJudgementAdd;
  requestMakeJudgementAddDecision: Function;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  requestValidateExpertReport: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestValidateJudgementOnMerits: Function;
  requestValidateDisclaimerWarranty: Function;
  requestGetJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  documentId: string;
  setDocumentId: Function;
  judgementAppeal: IAppealPayload;
  requestGetJudgementAppeal: Function;
  requestValidateJudgementAppeal: Function;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  feeNotes: FeeNote[];
  feeNotesCount: number;
  resetUploadDocumentStore: Function;
  requestManagerFeeNotes: Function;
  requestFeeNotesByClaimNumb: Function;
  requestCreateFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  keyclokToken: string | null;
  makeDecisionFeeNote: Function;
  currentTabInstance: string;
  setCurrentInstanceTab: Function;
  requestAllFeeNotes: Function;
  allFeeNote: FeeNote[];
  requestCorporealLawyers: Function;
  corporealLawyers: any;
  requestCreateCivilProceeding: Function;
  requestGetCivilProceeding: Function;
  judiciaryProcessId: number;
  civilProceeding: [];
  requestCreateJudgementOnMerits: Function;
  requestAssignedExpert: Function;
  requestUpdatedCivilProceeding: Function;
  selectedClaim: any;
  requestSagisClaimInfo: Function;
  sagisClaim: any;
  dahirAmountsCorpo: any;
  requestGetDahirAmountCorpo: Function;
  requestCreateJudgementOnMeritsContestation: any;
  requestGetJudgementOnMeritsAppeal: any;
  judgementOnMeritsAppeal: any;
  expertiseRaportAppeal: any;
  requestGetExpertiseReportAppeal: any;
  requestGetJudgementAddAppeal: Function;
  requestValidatedCivilProceeding: Function;
  judgementAddAppeal: any;
  requestMakeJudgementAddDocumentDecision: Function;
  requestAssigment: Function;
  requestAddVictims: Function;
  linkToBeneficiaryCodes: SagisConfig[];
  updateContestation: Function;
  requestUploadContestationDocument: Function;
  requestUpdateVictimInfo: Function;
  requestUpdateBeneficiaryInfo: Function;
  requestUpdateVehicleInfo: Function;
  setClaimRecap: Function;
  requestAddVehicles: Function;
  requestGetJudgementOnMeritsMultiple: Function;
  requestGetAppealOnMeritsMultiple: Function;
  judgementOnMeritsMultiple: any;
  appealOnMeritsMultiple: any;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVictims: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  judgementOnMeritsByVehicles: any;
  requestGetExpertiseVictim: Function;
  requestMakeDecisionMissionExpertise: Function;
  searchQuery: any;
  requestMakeDecisionMissionNoticeDeficiency: Function;
  requestGetExpertUsers: Function;
  corporealExperts: any;
  requestUpdateFeeNoteAmount: Function;
  selectedSearchResult: any;
  expertExpertise: any;
  requestCreateJudgementAdd: Function;
  requestUpdateJudgementAdd: Function;
  requestUpdateCivilProceeding: Function;
  loaders: any;
  currentIndexTabManager: any;
  currentGlobalTabManagerIndex: any;
  currentJudiciaryProccessId: any;
  currentInstanceTabIndexManager: any;
  requestUnlockClaim: Function;
  requestLockClaim: Function;
  setLockedClaim: Function;
  managerNotifcationsInboxes: any;
  resetSagisInfoClaim: Function;
  requestCheckCivilPartyJudiciaryProcess: Function;
  claimHasCivilPartyJudiciaryProcess: any;
  resetLegalProceeding: Function;
  resetStoreClaim: Function;
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestGetClaimHistoryActions: Function;
  userActions: any;
  setDecisionsJudgementIds: Function;
  claimHistorySagis: any;
  requestGetClaimHistorySagis: Function;
  requestSetStatusClaimSagis: Function;
  requestResetHistoryStore: Function;
  requestAddJudgementOnMeritsSupportDocument: Function;
  requestCreateFeeNoteManager: Function;
  requestSetPriorityClaimProvision: Function;
  requestGetFeeNotesTransaction: Function;
  requestGetTransaction: Function;
  requestAddTransaction: Function;
  resetStoreTransaction: Function;
  requestUpdateTransaction: Function;
  requestAddContactTransaction: Function;
  requestGetContactTransaction: Function;
  requestGetMissionTransaction: Function;
  requestGetMissionVictimExpertise: Function;
  requestUpdateContactTransaction: Function;
  requestUpdateMissionTransaction: Function;
  requestGetReportsPolicy: Function;
  requestUploadDocumentManager: Function;
  requestGetDocByDocumentumId: Function;
  requestGetJudgements: Function;
  requestUpdateFirmReferenceManager: Function;
}

export const CourtMonitoringManagerLegalProceedingsPage: React.FC<CourtManagerLegalProceedingsPageProps> = (
  props,
): JSX.Element => {
  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );
  const [victimValidation, setVictimValidation] = useState({});

  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      return () => {
        props.requestUnlockClaim(
          {
            claimNumber: get(props.claimRecap, 'claim.claimNumber'),
          },
          () => {
            props.setLockedClaim(null);
            props.resetSearchClaimsStore();
            props.resetStoreClaim();
            props.resetSagisInfoClaim();
            props.resetLegalProceeding();
            props.requestResetHistoryStore();
          },
        );
      };
    } else {
      return () => {
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.resetSagisInfoClaim();
        props.resetLegalProceeding();
        props.requestResetHistoryStore();
      };
    }
  }, []);

  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      const handleBeforeUnload = (event: any) => {
        const message = 'vous allez quitter le mode de gestion du sins';
        event.returnValue = message;
        props.requestUnlockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
      };

      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    } else {
      return () => {
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.resetSagisInfoClaim();
        props.resetLegalProceeding();
        props.requestResetHistoryStore();
      };
    }
  }, []);

  useDeepCompareEffect(() => {
    if (!isEmpty(get(props.policyInfo, 'sagis', []))) {
      if (
        !isLockedClaim(props.policyInfo) &&
        featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM) &&
        !isNil(get(props.claimRecap, 'claim.claimNumber', null)) &&
        !isBlockStatusClaim(props.policyInfo)
      ) {
        props.requestLockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
        props.setLockedClaim(get(props.claimRecap, 'claim.claimNumber'));
      }
    }
  }, [props.claimRecap, props.policyInfo]);
  useEffect(() => {
    if (
      !isEmpty(get(props.policyInfo, 'sagis', [])) &&
      featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
      (isNil(get(props.claimRecap, 'claim.priorityReasonId', null)) ||
        get(props.claimRecap, 'claim.priorityReasonId', null) != 4)
    ) {
      const priorityReason = priorityClaimReason(
        [],
        !isEmpty(get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []))
          ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks', [])
              .map((el: any) => Number(el.riskProvisions))
              .reduce(
                (accumulator: any, currentValue: any) =>
                  accumulator + currentValue,
              )
          : 0,
        props.listings,
      );
      if (priorityReason) {
        props.requestSetPriorityClaimProvision({
          id: Number(props.match.params.claimId),
          claimInfo: { priorityReasonId: priorityReason },
          username: currentUserStorage.get().username,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        });
      }
    }
  }, [props.policyInfo]);
  useEffect(() => {
    if (
      !isEmpty(props.claimRecap) &&
      get(props, 'claimRecap.claim.status') != GLOBAL_STATUS.VALIDATED
    ) {
      props.requestUnlockClaim(
        {
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        },
        () => {
          routesHelper.pushTo(
            `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(props, [
              'match',
              'params',
              'claimId',
            ])}`,
          )();
        },
      );
    }
  }, [props.claimRecap]);
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [procedureType, setProcedureType] = React.useState<null | number>(null);
  const [civilProceedingInfo, setCivilProceedingInfo] = React.useState<
    null | any
  >({});
  const [page, setPage] = React.useState<number>(0);
  const [victimsInfo, setVictimsInfo] = React.useState<null | any>([]);
  const claimId = props.match.params.claimId;
  const claimNumber = get(props.claimRecap, 'claim.claimNumber', null);
  const [civilProceedingDoc, setCivilProceedingDoc] = React.useState<
    null | any
  >([]);
  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);
  const [
    isDialogOpenCivilProceeding,
    setIsDialogOpenCivilProceeding,
  ] = React.useState<boolean>(false);
  const [openTrackingDrawer, setOpenTrackingDrawer] = useState(false);

  useEffect(() => {
    if (isDialogOpenCivilProceeding === false) {
      cleanCivilProceedingStates();
    }
  }, [isDialogOpenCivilProceeding]);
  const [idCivilProceeding, setIdCivilProceeding] = React.useState<number>(0);
  const [isWarrantyDialogOpen, setIsWarrantyDialogOpen] = useState<boolean>(
    false,
  );
  const [currentJudiciaryProcess, setCurrentJudiciaryProcess] = React.useState<
    any
  >({});
  const [isAssignmentDialogOpen, setIsAssignmentDialogOpen] = React.useState<
    boolean
  >(false);
  const [judiciaryProcessType, setJudiciaryProcessType] = React.useState<
    string
  >('');

  const handleCloseAssignmentDialog = () => {
    setIsAssignmentDialogOpen(false);
  };
  const [
    isAssignmentClaimDrawerOpen,
    setIsAssignmentClaimDrawerOpen,
  ] = useState<boolean>(false);
  const [isAddVictimCardOpen, setIsAddVictimCardOpen] = useState<boolean>(
    false,
  );

  useEffect(() => {
    const correctionnelProceeding = props.civilProceeding.filter(
      (element: { procedureNatureId: number }) =>
        element.procedureNatureId === 3,
    );
    const claimId = get(props, ['match', 'params', 'claimId']);
    props.requestGetCivilProceeding(claimId);
    props.requestCheckCivilPartyJudiciaryProcess(claimId);
    props.requestClaimRecap(claimId);
    setIdCivilProceeding(get(correctionnelProceeding, '[0].id'));
    if (get(props.civilProceeding, '[0].id')) {
      props.getLegalProceedingsSteps(
        claimId,
        get(props.civilProceeding, '[0].id'),
      );
      props.requestClaimRecap(claimId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claimId, claimNumber]);

  useEffect(() => {
    if (
      !isEmpty(get(props.policyInfo, 'sagis', {})) &&
      !isEmpty(props.claimRecap)
    ) {
      if (isLockedClaim(props.policyInfo)) {
        toast.error(
          translate({ ...messages.errorLockedClaim }, props, {
            username: get(
              resolveSagisClaim(props.policyInfo),
              'lockedBy',
              null,
            ),
          }) as string,
        );
        props.setLockedClaim(null);
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.resetSagisInfoClaim();
        props.resetLegalProceeding();
        props.requestResetHistoryStore();
        routesHelper.pushTo(
          `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(props, [
            'match',
            'params',
            'claimId',
          ])}`,
        )();
      } else if (
        isBlockStatusClaim(props.policyInfo) ||
        get(props, 'claimRecap.claim.status') != GLOBAL_STATUS.VALIDATED
      ) {
        props.resetStoreClaim();
        props.resetSearchClaimsStore();
        routesHelper.pushTo(
          `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(props, [
            'match',
            'params',
            'claimId',
          ])}`,
        )();
      }
    }
  }, [props.policyInfo, props.claimRecap]);
  React.useEffect(() => {
    const _stackholders = util.getListBySagisKey(
      get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(props.listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = util.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listings]);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    props.requestCorporealLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!_.isEmpty(props.corporealLawyers)]);
  useEffect(() => {
    if (claimId) {
      props.requestGetExpertiseVictim({
        missionId: null,
        claimId,
        missionVictimId: null,
        isIntervenant: false,
        isLegalProceeding: true,
      });
    }
  }, [!claimId]);
  useEffect(() => {
    props.requestCorporealLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!_.isEmpty(props.corporealLawyers)]);

  const handleOpen = () => {
    props.setDecisionsJudgementIds({});
    setIsDialogOpen(true);
  };

  const handleOpenCivilProceeding = (type: number) => () => {
    setIsDialogOpenCivilProceeding(true);
    setDropDown(null);
    setProcedureType(type);
    retoreCvilProceedingLocalState();
  };

  const handleOpenDisclaimerWarrantyReasons = () =>
    setIsWarrantyDialogOpen(true);

  const toggleDrawerAssignmentClaim = () => {
    setIsAssignmentClaimDrawerOpen(!isAssignmentClaimDrawerOpen);
  };

  const toggleAddVictimCard = () => {
    setIsAddVictimCardOpen(!isAddVictimCardOpen);
  };

  const handleCloseWarrantyDialog = () => setIsWarrantyDialogOpen(false);

  const successCallBackValidationWarrantyReason = () => {
    toast.success(translate(messages.successDialogWarrantyReason, props));
    setIsWarrantyDialogOpen(false);
  };

  const handleValidateWarrantyDialog = (reasonId: number) => () => {
    props.requestValidateDisclaimerWarranty(
      { id: claimId, reasonId },
      successCallBackValidationWarrantyReason,
    );
  };

  const handleToggleTrackingDrawer = () => {
    setOpenTrackingDrawer(!openTrackingDrawer);
  };

  const handleOpenUpdateFormCivilProceeding = (payload: any) => {
    setIsDialogOpenCivilProceeding(true);
    setCivilProceedingInfo({
      ...payload,
      dateReceiptRequest: payload.receptionDate,
    } as any);
    setAssociatedVictims(payload.victims.map((item: any) => item.id));
    setClaimType({
      corporeal: !isEmpty(payload.victims),
      material: !isEmpty(payload.vehicules) || !isEmpty(payload.otherDamage),
    });
    setAssociatedOpposingParties(payload.vehicules.map((item: any) => item.id));
    setDamage({
      adverseVehicles: !isEmpty(payload.vehicules),
      otherProperties: !isEmpty(payload.otherDamage),
    });
    setCivilProceedingDoc(get(payload, 'documents'));
    setOtherDamage(get(payload, 'otherDamage.[0]', OTHER_DAMAGE_INIT_STATE));
  };

  const handleClose = () => {
    props.setDecisionsJudgementIds({});
    setIsDialogOpen(false);
  };
  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    if (
      featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) &&
      !isNil(claimNumber)
    ) {
      props.requestGetClaimHistoryActions(claimId);
      props.requestGetClaimHistorySagis(claimNumber);
    }
  }, [claimId, claimNumber]);

  const handleCloseCivilProceeding = () => {
    setOtherDamage(OTHER_DAMAGE_INIT_STATE);
    setDamage(DAMAGE_INIT_STATE);
    setIsDialogOpenCivilProceeding(false);
  };

  const cleanCivilProceedingStates = () => {
    setIsDialogOpenCivilProceeding(false);
    retoreCvilProceedingLocalState();
  };
  const retoreCvilProceedingLocalState = () => {
    setOtherDamage(OTHER_DAMAGE_INIT_STATE);
    setCivilProceedingInfo({});
    setDamage(DAMAGE_INIT_STATE);
    setClaimType(CLAIM_TYPE_INIT_STATE);
    setVehicleFormValues(VEHICLE_FORM_VALUES_INIT_STATE);
    setVictimFormValues(VICTIM_FORM_VALUES_INIT_STATE);
    setCivilProceedingDoc([]);
  };

  const successCallBack = () => {
    toast.success(translate(messages.successDialogCivilProceeding, props));
    cleanCivilProceedingStates();
  };

  const successCallBackUpdate = () => {
    toast.success(translate(messages.updatedRequest, props));
    cleanCivilProceedingStates();
  };

  const successCallBackAddVictims = () => {
    toast.success(translate(messages.successDialogAddVictims, props));
    toggleAddVictimCard();
  };

  const riskKey =
    props.policyInfo &&
    get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []).find(
      (element: { riskName: string }) => element.riskName === rcCoporeal,
    )?.riskId;

  const formatLabel = (
    label: string,
    index: string,
    isProceedingCivil: boolean,
  ) => {
    if (!isProceedingCivil) {
      return label;
    } else {
      return label + ' ' + index;
    }
  };
  const ListProceeding = [
    {
      id: 1,
      title: 'Procédure commerciale',
    },
    {
      id: 2,
      title: 'Procédure civile',
    },
    {
      id: 3,
      title: 'Procédure correctionelle',
    },
  ];

  const handleValidateProceedingCivil = () => {
    const date = new Date(get(props.claimRecap, 'claim.lossDate'));
    const dayOfMonth = date.getDate();
    const lawyerJurisdictionAssignedCode = featureService.hasFeature(
      FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
    )
      ? getAssignedJurisdictionLawyerCode(
          get(props.listings, LISTINGS.MAPPING_LAWYER_JURISDICTION, []),
          civilProceedingInfo.town,
          dayOfMonth,
        )
      : '';
    const formattedVictims = userPrivileges.userHasPrivilege(
      PRIVILEGES.ISCOURTMONITORINGMANAGER,
    )
      ? []
      : [...Object.values(victimFormValues)].map((victim: VictimType) => {
          let setDefaultBirthDate = false;
          if (victim[VICTIM.DATE_OF_BIRTH] === 'Invalid Date') {
            setDefaultBirthDate = true;
          }
          return {
            ...victim,
            victimFirstName: victim[VICTIM.FIRST_NAME],
            victimLastName: victim[VICTIM.LAST_NAME],
            victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
            gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
            injuryCode:
              String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
                ? victim[VICTIM.INJURY_POST_KEY]
                : 0,
            qualityVictim: victim[VICTIM.QUALITY_KEY],
            classVictim: victim[VICTIM.CLASS_KEY],
            Town: victim[VICTIM.CITY],
            isExcluded: false,
            cspCode: get(
              get(props.listings, 'Profession', []).find(
                (el: any) => el.ItemKey === victim.professionCode,
              ),
              'ItemGroup',
              null,
            ),
            gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
            Complement: victim[VICTIM.ADDRESS],
            isWorkAccident:
              victim[VICTIM.WORK_ACCIDENT_ID] === 1 ? true : false,
            setDefaultBirthDate,
            itt: parseInt((victim[VICTIM.ITT] as unknown) as string),
            annualOfIncome:
              ((victim.annualOfIncome as unknown) as string) === ''
                ? null
                : victim.annualOfIncome,
            annualInCome:
              ((victim.annualOfIncome as unknown) as string) === ''
                ? undefined
                : victim.annualOfIncome,
          };
        });
    props.requestCreateCivilProceeding(
      {
        claimId: claimId,
        riskKey: riskKey,
        circonscription: civilProceedingInfo.circonscription,
        assignedLawyers: featureService.hasFeature(
          FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
        )
          ? [lawyerJurisdictionAssignedCode]
          : civilProceedingInfo.assignedLawyers,
        procedureNatureId: procedureType,
        town: civilProceedingInfo.town,
        claimNumbers: claimNumber,
        opposingLawyer: civilProceedingInfo.opposingLawyer,
        jurisdictionDegreeId: civilProceedingInfo.jurisdictionDegreeId,
        receptionDate: civilProceedingInfo.receptionDate,
        hearingDate: civilProceedingInfo.hearingDate,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        documents: civilProceedingDoc,
        courtNumber: formatCourtFileNumber(civilProceedingInfo.courtNumber),
        victims: claimType.corporeal
          ? [...Object.values(victimFormValues)].map((el: any) => ({
              ...el,
              itt: el.itt === '' ? null : el.itt,
              annualOfIncome:
                el.annualOfIncome === '' ? null : el.annualOfIncome,
              isExcluded: !!el.isExcluded,
              beneficiaries: el.beneficiaries.map((item: any) => ({
                ...item,
                funeralFees:
                  item.funeralFees === '' ? undefined : item.funeralFees,
              })),
            }))
          : undefined,
        priorityReasonId: addPriorityReasonProfession(
          priorityReasonClaimId,
          !![...Object.values(victimFormValues)].find((v: any) =>
            PROFESSION_CODES.includes(v.professionCode),
          ),
          props.listings,
        ),
        victimsSagis: formattedVictims,
        associatedVictims,
        updateSagisIntervenantProvision: featureService.hasFeature(
          FEATURES.EVOLUTION_P3,
        )
          ? false
          : true,
        username: currentUserStorage.get().username,
        otherDamage: damage.otherProperties ? otherDamage : undefined,
        opposingParties: damage.adverseVehicles
          ? formatOpposingParties(
              Object.values(vehicleFormValues),
              riskId,
              claimNumber,
              claimId,
              props.listings?.compagnies,
            )
          : undefined,
        associatedOpposingParties,
        isCourtMonitoringManager: userPrivileges.userHasPrivilege(
          PRIVILEGES.ISCOURTMONITORINGMANAGER,
        ),
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isOptionalDataGsj: featureService.hasFeature(
          FEATURES.GSJ_OPTIONAL_DATA,
        ),
        isAutomaticAssignement: featureService.hasFeature(
          FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
        ),
        status: userPrivileges.userHasPrivilege(
          PRIVILEGES.ISCOURTMONITORINGMANAGER,
        )
          ? ALL_STATUS.PENDING
          : ALL_STATUS.VALIDATED,
        creator: currentUserStorage.get().username,
        isLawyerInboxesActive: featureService.hasFeature(
          FEATURES.LAWYER_INBOXES,
        ),
      },
      successCallBack,
    );
  };

  const handleUpdateProceedingCivil = () => {
    const date = new Date(get(props.claimRecap, 'claim.lossDate'));
    const dayOfMonth = date.getDate();
    const lawyerJurisdictionAssignedCode = featureService.hasFeature(
      FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
    )
      ? getAssignedJurisdictionLawyerCode(
          get(props.listings, LISTINGS.MAPPING_LAWYER_JURISDICTION, []),
          civilProceedingInfo.town,
          dayOfMonth,
        )
      : '';
    props.requestUpdateCivilProceeding(
      {
        id: civilProceedingInfo.id,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        JudiciaryProcessInfo: {
          claimId: claimId,
          riskKey: riskKey,
          circonscription: civilProceedingInfo.circonscription,
          assignedLawyer: featureService.hasFeature(
            FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
          )
            ? lawyerJurisdictionAssignedCode
            : civilProceedingInfo.assignedLawyer,

          town: civilProceedingInfo.town,
          claimNumbers: claimNumber,
          updateSagisIntervenantProvision: featureService.hasFeature(
            FEATURES.EVOLUTION_P3,
          )
            ? false
            : true,
          opposingLawyer: civilProceedingInfo.opposingLawyer,
          jurisdictionDegreeId: civilProceedingInfo.jurisdictionDegreeId,
          receptionDate: civilProceedingInfo.receptionDate,
          hearingDate: civilProceedingInfo.hearingDate,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          courtNumber: formatCourtFileNumber(civilProceedingInfo.courtNumber),
          victims: claimType.corporeal
            ? [...Object.values(victimFormValues)].map((el: any) => ({
                ...el,
                itt: el.itt === '' ? null : el.itt,
                isExcluded: !!el.isExcluded,
              }))
            : undefined,
          associatedVictims: claimType.corporeal ? associatedVictims : [],
          username: currentUserStorage.get().username,
          otherDamage:
            damage.otherProperties && claimType.material
              ? otherDamage
              : undefined,
          opposingParties: damage.adverseVehicles
            ? formatOpposingParties(
                Object.values(vehicleFormValues),
                riskId,
                claimNumber,
                claimId,
                props.listings?.compagnies,
              )
            : undefined,
          associatedOpposingParties:
            claimType.material && damage.adverseVehicles
              ? associatedOpposingParties
              : [],
          isCourtMonitoringManager: userPrivileges.userHasPrivilege(
            PRIVILEGES.ISCOURTMONITORINGMANAGER,
          ),
          status: ALL_STATUS.PENDING,
          creator: currentUserStorage.get().username,
        },
        documents: extractUpdatedDocument(civilProceedingDoc),
      },
      successCallBackUpdate,
    );
  };

  const [damage, setDamage] = useState<DamageType>(DAMAGE_INIT_STATE);

  const [claimType, setClaimType] = useState({
    corporeal: false,
    material: false,
  });
  const [OpenDrawerImagineDocuments, setOpenDraweImagineDocuments] = useState(
    false,
  );

  const handleToggleDrawer = () => {
    setOpenDraweImagineDocuments(!isDrawerOpen);
  };

  const [otherDamage, setOtherDamage] = useState(OTHER_DAMAGE_INIT_STATE);

  const [vehicleFormValues, setVehicleFormValues] = useState<{
    [key: string]: VehicleForm;
  }>({});

  const addVehicleForm = () => {
    setVehicleFormValues(prevVehicleFormValues => {
      return {
        ...prevVehicleFormValues,
        [_.uniqueId()]: VEHICLE_FORM_INIT_STATE,
      };
    });
  };

  const [victimFormValues, setVictimFormValues] = useState<{
    [key: string]: VictimType;
  }>({});

  const [associatedVictims, setAssociatedVictims] = useState<any[]>([]);
  const [associatedOpposingParties, setAssociatedOpposingParties] = useState<
    any[]
  >([]);

  const addVictimForm = () => {
    setVictimFormValues(prevVictimFormValues => {
      return {
        ...prevVictimFormValues,
        [_.uniqueId()]: VICTIM_FORM_INIT_STATE,
      } as any;
    });
  };

  const handleChangeOtherDamage = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOtherDamage({
      ...otherDamage,
      description: e.target.value.substring(
        0,
        OTHER_PROPERTIES_DESCRIPTION_SIZE_LIMIT,
      ),
    });
  };

  let labes = _.orderBy(
    props.civilProceeding,
    ['procedureNatureId'],
    ['desc'],
  ).map(
    (
      el: {
        procedureNatureId: number;
        id: number;
        courtNumber: string;
      },
      index,
    ) =>
      formatLabel(
        get(
          ListProceeding.filter(element => element.id === el.procedureNatureId),
          '[0].title',
        ),
        el.courtNumber,
        el.procedureNatureId === 3 ? false : true,
      ),
  );

  let labesWithIds = _.orderBy(
    props.civilProceeding,
    ['procedureNatureId'],
    ['desc'],
  ).map(
    (
      el: {
        procedureNatureId: number;
        id: number;
        courtNumber: string;
      },
      index,
    ) => {
      return {
        id: el.id,
        label: formatLabel(
          get(
            ListProceeding.filter(
              element => element.id === el.procedureNatureId,
            ),
            '[0].title',
          ),
          el.courtNumber,
          el.procedureNatureId === 3 ? false : true,
        ),
      };
    },
  );

  const handleClickVerticalTabs = (tabIndex: number) => {
    const idCivilProceeding = labesWithIds[tabIndex]?.id;
    props.civilProceeding.forEach(
      (el: { procedureNatureId: number; id: number; courtNumber: string }) => {
        if (el.id === idCivilProceeding) {
          setIdCivilProceeding(el.id);
          setCurrentJudiciaryProcess(el);
        }
      },
    );
  };

  const riskId = getRiskIdFromPolicyInfo(props?.policyInfo);

  const [victimAddFormValues, setVictimAddFormValues] = useState<{
    [key: string]: VictimType;
  }>({ [_.uniqueId()]: VICTIM_FORM_INIT_STATE } as any);

  const addVictimCardForm = () => {
    setVictimAddFormValues(prevVictimFormValues => {
      return {
        ...prevVictimFormValues,
        [_.uniqueId()]: VICTIM_FORM_INIT_STATE,
      } as any;
    });
  };

  const validateVictimCardForm = () => {
    const claimResponsabilityRate =
      props.policyInfo &&
      get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []).find(
        (element: { riskName: string }) => element.riskName === rcCoporeal,
      )?.responsibilityRate;
    const victimFormValues = [...Object.values(victimAddFormValues)].map(
      (el: any) => {
        return {
          ...el,
          itt: el.itt === '' ? null : el.itt,
          annualOfIncome: el.annualOfIncome === '' ? null : el.annualOfIncome,
          claimId,
          isExcluded: !!el.isExcluded,
          beneficiaries: el.beneficiaries.map((item: any) => ({
            ...item,
            funeralFees: item.funeralFees === '' ? undefined : item.funeralFees,
          })),
        };
      },
    );
    let isFormValid = false;
    [...Object.values(victimAddFormValues)].forEach((el: any) => {
      const validator = victimValidator(el);
      setVictimValidation(validator);
      if (formsAreValidated(validator ? validator : {})) {
        isFormValid = true;
      }
    });
    if (isFormValid) {
      const formattedVictims = victimFormValues.map((victim: VictimType) => {
        let setDefaultBirthDate = false;
        if (isEmpty(victim[VICTIM.DATE_OF_BIRTH])) {
          setDefaultBirthDate = true;
        }
        if (victim.injuryPostKey === INJURY_POST_DECEASED) {
          victim.nextOfKins = victim.beneficiaries.map((el: any) => {
            return {
              fullName: `${removeWhiteSpaceFromString(
                el.firstName,
              )} ${removeWhiteSpaceFromString(el.lastName)}`,
              qualityCode: Number(el.beneficiaryType),
              age: el.age,
              birthDate: el?.dateOfBirth,
              funeralFees: featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)
                ? el.funeralFees
                : !isNil(el.funeralFees) && !!Number(claimResponsabilityRate)
                ? el.funeralFees / (Number(claimResponsabilityRate) / 100)
                : el.funeralFees,
              handicapIndicator: el.handicapIndicator ? 'Y' : 'N',
              dependentIndicator: el.dependentIndicator ? 'Y' : 'N',
            };
          });
        }

        return {
          ...victim,
          victimFirstName: victim[VICTIM.FIRST_NAME],
          victimLastName: victim[VICTIM.LAST_NAME],
          victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
          injuryCode:
            String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
              ? victim[VICTIM.INJURY_POST_KEY]
              : 0,
          qualityVictim: victim[VICTIM.QUALITY_KEY],
          classVictim: victim[VICTIM.CLASS_KEY],
          Town: victim[VICTIM.CITY],
          isExcluded: false,
          Complement: victim[VICTIM.ADDRESS],
          isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
          setDefaultBirthDate,
          gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
          cspCode: get(
            get(props.listings, 'Profession', []).find(
              (el: any) => el.ItemKey === victim.professionCode,
            ),
            'ItemGroup',
            null,
          ),
          itt: parseInt((victim[VICTIM.ITT] as unknown) as string),
          annualOfIncome:
            ((victim.annualOfIncome as unknown) as string) === ''
              ? null
              : victim.annualOfIncome,
          annualInCome:
            ((victim.annualOfIncome as unknown) as string) === ''
              ? undefined
              : victim.annualOfIncome,
        };
      });
      props.requestAddVictims(
        {
          victimsSagisToAdd: formattedVictims,
          victimsCorpoToAdd: victimFormValues,
          priorityReasonId: addPriorityReasonProfession(
            priorityReasonClaimId,
            !!victimFormValues.find((v: any) =>
              PROFESSION_CODES.includes(v.professionCode),
            ),
            props.listings,
          ),
          riskKey,
          claimNumber,
          claimId,
          isCourtMonitoringManager: false,
        },
        successCallBackAddVictims,
      );
    }
  };

  const handleResetStore = () => {
    props.requestUnlockClaim(
      {
        claimNumber: get(props.claimRecap, 'claim.claimNumber'),
      },
      () => {
        props.setLockedClaim(null);
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.requestResetHistoryStore();
      },
    );
  };
  const tabs = {
    SUMMARY: {
      id: 0,
      title: translate(messages.courtManagerRecapTitle, props),
      feature: true,
    },
    JUDICIARY_PROCESS: {
      id: 1,
      title: translate(messages.judiciaryProcessTabTitle, props),
      feature: true,
    },
    PROVISION_AND_REGULATION: {
      id: 1,
      title: translate(messages.provisionTab, props),
      feature: featureService.hasFeature(FEATURES.PROVISION),
    },
    EXPERT_INTEGRATION: {
      id: 1,
      title: translate(messages.expertise, props),
      feature: featureService.hasFeature(FEATURES.EXPERT_INTEGRATION),
    },
    TRANSACTION: {
      id: 1,
      title: translate(messages.transactionTabTitle, props),
      feature: featureService.hasFeature(FEATURES.TRANSACTION),
    },
  };
  const isUsageOpening =
    featureService.hasFeature(FEATURES.OPENING_BY_USAGE) &&
    get(props.claimRecap, 'claim.openingState', null) ===
      OPENING_STATE.NOT_COMPLETED;
  const { currentTabIndex, labels = [] } = claimTabs(tabs);
  return (
    <Container>
      <StyledTopDiv>
        {get(props.claimRecap['claim'], ['suspicious']) &&
          featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
            <SuspiciousCard />
          )}
        {shouldShowVictimExcludedWarning(
          get(props.claimRecap, 'victims'),
          featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE),
        ) && (
          <WarningCard
            message={messages.victimExcludedFromCoverageWarningMessage}
          />
        )}
        <TopCard
          claimNumber={get(props.claimRecap['claim'], 'claimNumber', '')}
          claimRecap={props.claimRecap}
          sagisClaim={props.sagisClaim}
          inputProps={{ disableUnderline: true }}
          intl={props.intl}
          setDropDown={setDropDown}
          dropDown={dropDown}
          toggleDrawer={toggleDrawer}
          handleOpenCivilProceeding={handleOpenCivilProceeding}
          handleOpenDisclaimerWarrantyReasons={
            handleOpenDisclaimerWarrantyReasons
          }
          requestSagisClaimInfo={props.requestSagisClaimInfo}
          toggleDrawerAssignmentClaim={toggleDrawerAssignmentClaim}
          toggleAddVictimCard={toggleAddVictimCard}
          assignedLawyer={get(
            get(props.claimRecap, 'claim.assignment', []).filter(
              (el: any) => !isNil(el.assignedLawyer),
            ),
            '[0].assignedLawyer',
            null,
          )}
          setIsAssignmentDialogOpen={setIsAssignmentDialogOpen}
          setOpenIsSuspiciosClaimDialog={() => {}}
          handleToggleImagineDocDrawer={handleToggleDrawer}
          resetSagisInfoClaim={props.resetSagisInfoClaim}
          claimHasCivilPartyJudiciaryProcess={get(
            props.claimHasCivilPartyJudiciaryProcess,
            'checkCivilPartyJudiciaryProcess',
          )}
          handleToggleTrackingDrawer={handleToggleTrackingDrawer}
          requestSetStatusClaimSagis={props.requestSetStatusClaimSagis}
          isConsultation={false}
          listings={props.listings}
          handleResetStore={handleResetStore}
          isAllDisabled={true}
        />
      </StyledTopDiv>
      {featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) && (
        <TrackingActionDrawer
          isDrawerOpen={openTrackingDrawer}
          setIsDrawerOpen={handleToggleTrackingDrawer}
          userActions={props.userActions}
          listings={props.listings}
          claimHistorySagis={props.claimHistorySagis}
          claimNumber={claimNumber}
          claimId={claimId}
          requestGetClaimHistoryActions={props.requestGetClaimHistoryActions}
          requestGetClaimHistorySagis={props.requestGetClaimHistorySagis}
          loaders={props.loaders}
        />
      )}
      {featureService.hasFeature(FEATURES.FEE_NOTE) && (
        <DialogFeeNote
          allFeeNote={props.allFeeNote}
          requestAllFeeNotes={props.requestAllFeeNotes}
          feeNotes={props.feeNotes}
          feeNotesCount={props.feeNotesCount}
          requestLawyerFeeNotes={props.requestFeeNotesByClaimNumb}
          requestCreateFeeNote={props.requestCreateFeeNote}
          requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
          keyclokToken={props.keyclokToken}
          resetUploadDocumentStore={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          makeDecisionFeeNote={props.makeDecisionFeeNote}
          open={isDialogOpen}
          handleClose={handleClose}
          showButtonAdd={false}
          title={translate(messages.FeeNoteTitle, props)}
          claimNumber={get(props.claimRecap, 'claim.claimNumber')}
          listings={props.listings}
          page={page}
          setPage={setPage}
          linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
          isExpert={true}
          requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
          loaders={props.loaders}
          requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
          requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
          contractorFeesSagis={get(props.sagisClaim, 'contractorFees', [])}
          requestUpdateFeeNoteStatus={() => {}}
          isConsultation={false}
          requestUpdateFirmReferenceManager={
            props.requestUpdateFirmReferenceManager
          }
        />
      )}
      {featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER) && (
        <ImagineDocumentsDrawer
          isDrawerOpen={OpenDrawerImagineDocuments}
          setIsDrawerOpen={setOpenDraweImagineDocuments}
          listings={props.listings}
          expandRow={false}
          setExpandRow={undefined}
          claimSagisInfo={resolveSagisClaim(props.policyInfo)}
          managerNotifcationsInboxes={props.managerNotifcationsInboxes}
          claimId={claimId}
          requestMakeDecisionsDocumentImaging={() => {}}
          requestGetNotificationsInboxes={() => {}}
          isConsultation={true}
          shouldDisplayUploadDocument={false}
          imagineNotification={{}}
          requestUploadDocumentManager={props.requestUploadDocumentManager}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      {isDrawerOpen && (
        <AssignExpertDrawer
          open={isDrawerOpen}
          handleToggleDrawer={toggleDrawer}
          listings={props.listings}
          victims={
            isUsageOpening
              ? get(props.claimRecap, 'victims', [])
              : filterVictim(get(props.claimRecap, 'victims', []))
          }
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          resetUploadedDocument={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          requestAssignedExpert={props.requestAssignedExpert}
          claimId={claimId}
          claimNumber={claimNumber}
          judiciaryProcessId={idCivilProceeding}
          courtFileNumber={getCourtFileNumber(
            props.civilProceeding,
            idCivilProceeding,
            props.judgementAdd,
          )}
          requestCorporealLawyers={props.requestCorporealLawyers}
          corporealLawyers={props.corporealLawyers}
          assignedLawyer={get(
            props.claimRecap,
            'claim.assignment[0].assignedLawyer',
          )}
          searchQuery={props.searchQuery}
          civilProceeding={props.civilProceeding}
          corporealExperts={props.corporealExperts}
          requestGetExpertUsers={props.requestGetExpertUsers}
          vehicles={filterVehicle(get(props.claimRecap, 'vehicules', []))}
          requestGetCivilProceeding={props.requestGetCivilProceeding}
          selectedSearchResult={props.selectedSearchResult}
          claimHasCivilPartyJudiciaryProcess={get(
            props.claimHasCivilPartyJudiciaryProcess,
            'checkCivilPartyJudiciaryProcess',
          )}
          riskKey={riskKey}
          claimRecap={props.claimRecap}
        />
      )}
      {featureService.hasFeature(FEATURES.CIVIL_PROCEEDING) && (
        <DialogCivilProceeding
          open={isDialogOpenCivilProceeding}
          title={
            procedureType === 2
              ? translate(messages.civilProceedingTitle, props)
              : translate(messages.commercialproceedingTitle, props)
          }
          handleClose={handleCloseCivilProceeding}
          confirmTitle={
            get(civilProceedingInfo, 'id', null)
              ? translate(messages.updateTitle, props)
              : translate(messages.civilAdd, props)
          }
          cancelTitle={translate(messages.civilCancel, props)}
          handleValidate={
            get(civilProceedingInfo, 'id', null)
              ? handleUpdateProceedingCivil
              : handleValidateProceedingCivil
          }
          disablePrimaryButton={
            !validationCourtFileNumber(
              get(civilProceedingInfo, [
                CIVIL_PROCEEDING_INFORMATIONS_FIELDS.COURT_NUMBER,
              ]),
            ) ||
            (claimType.corporeal && !claimType.material
              ? isEmpty(associatedVictims) && isEmpty(victimFormValues)
              : !claimType.corporeal && claimType.material
              ? (isEmpty(associatedOpposingParties) &&
                  isEmpty(vehicleFormValues)) ||
                (!isEmpty(vehicleFormValues) &&
                  !validationVehicle(Object.values(vehicleFormValues)))
              : (isEmpty(associatedVictims) && isEmpty(victimFormValues)) ||
                (isEmpty(associatedOpposingParties) &&
                  isEmpty(vehicleFormValues)) ||
                (!isEmpty(vehicleFormValues) &&
                  !validationVehicle(Object.values(vehicleFormValues)))) ||
            (featureService.hasFeature(
              FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
            ) &&
              isNil(
                get(
                  civilProceedingInfo,
                  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.TOWN],
                  null,
                ),
              ))
          }
          children={
            <CivilProceedingForm
              resetUploadedDocument={props.resetUploadDocumentStore}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              civilProceedingDoc={civilProceedingDoc}
              setCivilProceedingDoc={setCivilProceedingDoc}
              victimsInfo={victimsInfo}
              setVictimsInfo={setVictimsInfo}
              setDocumentId={props.setDocumentId}
              documentId={props.documentId}
              civilProceedingInfo={civilProceedingInfo}
              setCivilProceedingInfo={setCivilProceedingInfo}
              victims={
                isUsageOpening
                  ? get(props.claimRecap, 'victims', [])
                  : filterVictim(get(props.claimRecap, 'victims', []))
              }
              vehicles={filterVehicle(get(props.claimRecap, 'vehicules', []))}
              listings={props.listings}
              requestCorporealLawyers={props.requestCorporealLawyers}
              corporealLawyers={props.corporealLawyers}
              claimId={claimId}
              damage={damage}
              setDamage={setDamage}
              claimType={claimType}
              setClaimType={setClaimType}
              otherDamage={otherDamage}
              handleChangeOtherDamage={handleChangeOtherDamage}
              vehicleFormValues={vehicleFormValues}
              setVehicleFormValues={setVehicleFormValues}
              addVehicleForm={addVehicleForm}
              victimFormValues={victimFormValues}
              setVictimFormValues={setVictimFormValues}
              addVictimForm={addVictimForm}
              associatedVictims={associatedVictims}
              setAssociatedVictims={setAssociatedVictims}
              associatedOpposingParties={associatedOpposingParties}
              setAssociatedOpposingParties={setAssociatedOpposingParties}
              lossDate={get(props.claimRecap, 'claim.lossDate')}
              sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
              sagisOpposingParties={extractOpposingParties(
                get(props.sagisClaim, 'offeredRisks', []),
              )}
              claimRecap={props.claimRecap}
              disableAssignementInput={
                get(civilProceedingInfo, 'id', null) ? true : false
              }
            />
          }
        />
      )}
      {featureService.hasFeature(FEATURES.DISCLAIMER_WARRANTY) && (
        <DialogDisclaimerWarranty
          open={isWarrantyDialogOpen}
          confirmTitle={translate(messages.validateWarrantyReason, props)}
          cancelTitle={translate(messages.cancelWarrantyReason, props)}
          handleClose={handleCloseWarrantyDialog}
          handleValidate={handleValidateWarrantyDialog}
          title={translate(messages.ExlusionOfWarranty, props)}
          listings={props.listings}
        />
      )}
      {featureService.hasFeature(FEATURES.ASSIGNMENT_CLAIM) && (
        <>
          <AssignmentClaimDrawer
            open={isAssignmentClaimDrawerOpen}
            handleToggleDrawer={toggleDrawerAssignmentClaim}
            listings={props.listings}
            judiciaryProcess={props.civilProceeding}
            intervenants={get(props.listings, 'intervenants', [])}
            claimRecap={props.claimRecap}
            setIsAssignmentDialogOpen={setIsAssignmentDialogOpen}
            setJudiciaryProcessType={setJudiciaryProcessType}
            isConsultation={false}
          />
          <AssignmentDialog
            open={isAssignmentDialogOpen}
            onClose={handleCloseAssignmentDialog}
            subServices={get(props.listings, LISTINGS.SUB_SERVICES, [])}
            zonesCodes={get(props.listings, LISTINGS.ZONE_CODES, [])}
            services={get(props.listings, LISTINGS.SERVICES, [])}
            stackholders={get(props.listings, LISTINGS.STACKHOLDERS, [])}
            stackholderTypes={get(
              props.listings,
              LISTINGS.STACKHOLDER_TYPE,
              [],
            )}
            requestAssigment={props.requestAssigment}
            claim={(props.claimRecap.claim as unknown) as Claim}
            requestCorporealLawyers={props.requestCorporealLawyers}
            corporealLawyers={props.corporealLawyers}
            shouldAssignOnSagis={false}
            isManagerOpenedClaimsPage={false}
            listings={props.listings}
            claimNumber={get(props.claimRecap['claim'], 'claimNumber', '')}
            judiciaryProcessType={judiciaryProcessType}
            isClaim
            riskKey={riskKey}
          />
        </>
      )}
      {userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER) && (
        <DialogCivilProceeding
          open={isAddVictimCardOpen}
          title={translate(messages.addVictim, props)}
          handleClose={() => toggleAddVictimCard()}
          confirmTitle={translate(messages.civilAdd, props)}
          cancelTitle={translate(messages.civilCancel, props)}
          handleValidate={validateVictimCardForm}
          children={
            <VictimFormComponent
              victimFormValues={victimAddFormValues}
              setVictimFormValues={setVictimAddFormValues}
              addVictimForm={addVictimCardForm}
              claimId={claimId}
              listings={props.listings}
              claimRecap={props.claimRecap}
            />
          }
        />
      )}
      {featureService.hasFeature(FEATURES.CIVIL_PROCEEDING) && (
        <SahamTabsGlobal>
          <GlobalLegalProceedingTabs
            currentTabIndex={currentTabIndex}
            labels={labels}
            setCurrentInstanceTab={props.setCurrentInstanceTab}
          >
            <ClaimRecap
              listings={props.listings}
              storedClaimToPreopen={props.storedClaimToPreopen}
              requestClaimRecap={props.requestClaimRecap}
              claimRecap={props.claimRecap}
              policyInfo={props.policyInfo}
              requestSearchClaims={props.requestSearchClaims}
              resetSearchClaimsStore={props.resetSearchClaimsStore}
              claimId={claimId}
              shouldDisplayBreadCrumbs={false}
              className="recap-bloc"
              shouldNotGetClaim
              stakeholders={stakeholders}
              requestUpdateVictimInfo={props.requestUpdateVictimInfo}
              requestUpdateBeneficiaryInfo={props.requestUpdateBeneficiaryInfo}
              requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
              setClaimRecap={props.setClaimRecap}
              requestCreateVehicle={props.requestAddVehicles}
              requestCreateVictim={props.requestAddVictims}
              requestSagisClaimInfo={props.requestSagisClaimInfo}
              sagisInfo={props.sagisClaim}
              keycloakToken={props.keyclokToken}
              isMonitoringManager={true}
              requestGetReportsPolicy={props.requestGetReportsPolicy}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
            <JudiciaryProcessTabs
              currentTabIndex={0}
              labels={labes}
              handleClickVerticalTabs={handleClickVerticalTabs}
            >
              {labes.map((label, index) => {
                return (
                  <ManagerLegalProceedingsPage
                    currentJudiciaryProcess={
                      currentJudiciaryProcess
                        ? currentJudiciaryProcess
                        : props.currentJudiciaryProccessId
                    }
                    listings={props.listings}
                    onPressFeeNote={handleOpen}
                    storedClaimToPreopen={props.storedClaimToPreopen}
                    requestClaimRecap={props.requestClaimRecap}
                    getLegalProceedingsSteps={props.getLegalProceedingsSteps}
                    claimRecap={props.claimRecap}
                    currentSteps={props.currentSteps}
                    policyInfo={props.policyInfo}
                    requestSearchClaims={props.requestSearchClaims}
                    resetSearchClaimsStore={props.resetSearchClaimsStore}
                    match={props.match}
                    requestGetJudgementAdd={props.requestGetJudgementAdd}
                    judgementAdd={props.judgementAdd}
                    requestGetJudgementAddAppeal={
                      props.requestGetJudgementAddAppeal
                    }
                    judgementAddAppeal={props.judgementAddAppeal}
                    requestMakeJudgementAddDecision={
                      props.requestMakeJudgementAddDecision
                    }
                    requestGetExpertiseRaport={props.requestGetExpertiseRaport}
                    expertiseReport={props.expertiseReport}
                    requestValidateExpertReport={
                      props.requestValidateExpertReport
                    }
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    resetUploadedDocument={props.resetUploadDocumentStore}
                    requestValidateJudgementOnMerits={
                      props.requestValidateJudgementOnMerits
                    }
                    requestGetJudgementOnMerits={
                      props.requestGetJudgementOnMerits
                    }
                    requestGetJudgementOnMeritsAppeal={
                      props.requestGetJudgementOnMeritsAppeal
                    }
                    judgementOnMeritsAppeal={props.judgementOnMeritsAppeal}
                    expertiseRaportAppeal={props.expertiseRaportAppeal}
                    requestGetExpertiseReportAppeal={
                      props.requestGetExpertiseReportAppeal
                    }
                    judgementOnMerits={props.judgementOnMerits}
                    documentId={props.documentId}
                    setDocumentId={props.setDocumentId}
                    judgementAppeal={props.judgementAppeal}
                    requestGetJudgementAppeal={props.requestGetJudgementAppeal}
                    requestValidateJudgementAppeal={
                      props.requestValidateJudgementAppeal
                    }
                    requestGetDahirAmount={props.requestGetDahirAmount}
                    dahirAmount={props.dahirAmount}
                    feeNotes={props.feeNotes}
                    feeNotesCount={props.feeNotesCount}
                    resetUploadDocumentStore={props.resetUploadDocumentStore}
                    requestManagerFeeNotes={props.requestManagerFeeNotes}
                    requestFeeNotesByClaimNumb={
                      props.requestFeeNotesByClaimNumb
                    }
                    requestCreateFeeNote={props.requestCreateFeeNote}
                    keyclokToken={props.keyclokToken}
                    makeDecisionFeeNote={props.makeDecisionFeeNote}
                    currentTabInstance={props.currentTabInstance}
                    setCurrentInstanceTab={props.setCurrentInstanceTab}
                    requestAllFeeNotes={props.requestAllFeeNotes}
                    allFeeNote={props.allFeeNote}
                    requestCorporealLawyers={props.requestCorporealLawyers}
                    corporealLawyers={props.corporealLawyers}
                    requestCreateCivilProceeding={
                      props.requestCreateCivilProceeding
                    }
                    requestGetCivilProceeding={props.requestGetCivilProceeding}
                    judiciaryProcessId={idCivilProceeding}
                    civilProceeding={props.civilProceeding}
                    requestCreateJudgementOnMerits={
                      props.requestCreateJudgementOnMerits
                    }
                    requestUpdatedCivilProceeding={
                      props.requestUpdatedCivilProceeding
                    }
                    requestSagisClaimInfo={props.requestSagisClaimInfo}
                    sagisClaim={props.sagisClaim}
                    requestGetDahirAmountCorpo={
                      props.requestGetDahirAmountCorpo
                    }
                    dahirAmountsCorpo={props.dahirAmountsCorpo}
                    requestCreateJudgementOnMeritsContestation={
                      props.requestCreateJudgementOnMeritsContestation
                    }
                    requestValidatedCivilProceeding={
                      props.requestValidatedCivilProceeding
                    }
                    requestMakeJudgementAddDocumentDecision={
                      props.requestMakeJudgementAddDocumentDecision
                    }
                    updateContestation={props.updateContestation}
                    requestUploadContestationDocument={
                      props.requestUploadContestationDocument
                    }
                    requestUpdateVictimInfo={props.requestUpdateVictimInfo}
                    requestUpdateBeneficiaryInfo={
                      props.requestUpdateBeneficiaryInfo
                    }
                    requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
                    setClaimRecap={props.setClaimRecap}
                    requestAddVictims={props.requestAddVictims}
                    requestGetAppealOnMeritsMultiple={
                      props.requestGetAppealOnMeritsMultiple
                    }
                    requestGetJudgementOnMeritsMultiple={
                      props.requestGetJudgementOnMeritsMultiple
                    }
                    appealOnMeritsMultiple={props.appealOnMeritsMultiple}
                    judgementOnMeritsMultiple={props.judgementOnMeritsMultiple}
                    judgementOnMeritsByVictims={
                      props.judgementOnMeritsByVictims
                    }
                    requestGetJudgementOnMeritsByVictims={
                      props.requestGetJudgementOnMeritsByVictims
                    }
                    judgementOnMeritsByVehicles={
                      props.judgementOnMeritsByVehicles
                    }
                    requestGetJudgementOnMeritsByVehicles={
                      props.requestGetJudgementOnMeritsByVehicles
                    }
                    expertExpertise={props.expertExpertise}
                    requestMakeDecisionMissionExpertise={
                      props.requestMakeDecisionMissionExpertise
                    }
                    requestCreateJudgementAdd={props.requestCreateJudgementAdd}
                    requestUpdateJudgementAdd={props.requestUpdateJudgementAdd}
                    handleOpenUpdateFormCivilProceeding={
                      handleOpenUpdateFormCivilProceeding
                    }
                    loaders={props.loaders}
                    currentIndexTabManager={props.currentIndexTabManager}
                    currentGlobalTabManagerIndex={
                      props.currentGlobalTabManagerIndex
                    }
                    currentJudiciaryProccessId={
                      props.currentJudiciaryProccessId
                    }
                    currentInstanceTabIndexManager={
                      props.currentInstanceTabIndexManager
                    }
                    requestAddJudgementOnMeritsSupportDocument={
                      props.requestAddJudgementOnMeritsSupportDocument
                    }
                    requestGetReportsPolicy={props.requestGetReportsPolicy}
                    requestGetClaimCivilParty={() => {}}
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                    requestGetJudgements={props.requestGetJudgements}
                  />
                );
              })}
            </JudiciaryProcessTabs>
            {get(tabs['PROVISION_AND_REGULATION'], 'feature', false) && (
              <main>
                <>
                  {
                    <LegalProceedingTabs
                      labels={PROVISION_TAB_LABELS}
                      currentTabIndex={0}
                    >
                      <ProvisionContainer
                        claimNumber={claimNumber}
                        listings={props.listings}
                        requestSagisClaimInfo={props.requestSagisClaimInfo}
                        sagisClaim={props.sagisClaim}
                        setIsDetail={() => {}}
                        claimId={claimId}
                        isConsultation={false}
                        lossDate={get(props.claimRecap, 'claim.lossDate')}
                        uploadedDocument={props.uploadedDocument}
                        resetUploadDocumentStore={
                          props.resetUploadDocumentStore
                        }
                        uploadDocument={props.uploadDocument}
                        requestCreateFeeNoteManager={
                          props.requestCreateFeeNoteManager
                        }
                      />
                      <div></div>
                    </LegalProceedingTabs>
                  }
                </>
              </main>
            )}
            {get(tabs['EXPERT_INTEGRATION'], 'feature', false) && (
              <ExpertiseExpert
                match={props.match}
                requestMakeDecisionMissionExpertise={
                  props.requestMakeDecisionMissionExpertise
                }
                requestMakeDecisionMissionNoticeDeficiency={
                  props.requestMakeDecisionMissionNoticeDeficiency
                }
                requestFeeNotesByClaimNumb={props.requestFeeNotesByClaimNumb}
                claimNumber={get(props.claimRecap, 'claim.claimNumber')}
                isLawyer={true}
                onPressFeeNote={() => {}}
                currentTabManagerExpertise={0}
                riskKey={riskKey}
                setOpenFeeNoteDialog={() => {}}
                claimRecap={props.claimRecap}
                resetSearchClaimsStore={props.resetSearchClaimsStore}
                resetStoreClaim={props.resetStoreClaim}
                resetSagisInfoClaim={props.resetSagisInfoClaim}
                resetLegalProceeding={props.resetLegalProceeding}
                policyInfo={props.policyInfo}
                currentIndexTabManager={props.currentIndexTabManager}
                currentInstanceTabIndexManager={
                  props.currentInstanceTabIndexManager
                }
                currentTabInstance={props.currentTabInstance}
                requestSearchClaims={props.requestSearchClaims}
                requestSetPriorityClaimProvision={
                  props.requestSetPriorityClaimProvision
                }
                listings={props.listings}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                requestGetExpertiseVictim={props.requestGetExpertiseVictim}
              />
            )}
            {get(tabs['TRANSACTION'], 'feature', false) && (
              <Transaction
                match={props.match}
                claimNumber={claimNumber}
                claimRecap={props.claimRecap}
                resetSearchClaimsStore={props.resetSearchClaimsStore}
                resetStoreClaim={props.resetStoreClaim}
                resetSagisInfoClaim={props.resetSagisInfoClaim}
                resetLegalProceeding={props.resetLegalProceeding}
                policyInfo={props.policyInfo}
                requestSearchClaims={props.requestSearchClaims}
                requestGetTransaction={props.requestGetTransaction}
                requestAddTransaction={props.requestAddTransaction}
                uploadedDocument={props.uploadedDocument}
                resetUploadedDocument={props.resetUploadDocumentStore}
                uploadDocument={props.uploadDocument}
                requestUpdateTransaction={props.requestUpdateTransaction}
                requestAddContactTransaction={
                  props.requestAddContactTransaction
                }
                requestGetContactTransaction={
                  props.requestGetContactTransaction
                }
                resetStoreTransaction={props.resetStoreTransaction}
                requestUpdateContactTransaction={
                  props.requestUpdateContactTransaction
                }
                corporealExperts={props.corporealExperts}
                requestGetExpertUsers={props.requestGetExpertUsers}
                requestAssignedExpert={props.requestAssignedExpert}
                riskKey={riskKey}
                requestGetMissionTransaction={
                  props.requestGetMissionTransaction
                }
                requestMakeDecisionMissionExpertise={
                  props.requestMakeDecisionMissionExpertise
                }
                requestGetMissionVictimExpertise={
                  props.requestGetMissionVictimExpertise
                }
                requestUpdateMissionTransaction={
                  props.requestUpdateMissionTransaction
                }
                requestGetFeeNotesTransaction={
                  props.requestGetFeeNotesTransaction
                }
                onPressFeeNote={() => {}}
                isConsultation={true}
                expertJudiciaryExpertise={props.expertExpertise}
                requestImportMissionExpertise={() => {}}
                requestGetJudiciaryExpertReport={() => {}}
                requestMakeDecisionVictimInfo={() => {}}
                sagisInfo={props.sagisClaim}
                requestLockClaim={props.requestLockClaim}
                setLockedClaim={props.setLockedClaim}
                requestSetPriorityClaimProvision={
                  props.requestSetPriorityClaimProvision
                }
                requestResetHistoryStore={props.requestResetHistoryStore}
                currentIndexTabManager={props.requestResetHistoryStore}
                currentInstanceTabIndexManager={
                  props.currentInstanceTabIndexManager
                }
                currentGlobalTabManagerIndex={
                  props.currentGlobalTabManagerIndex
                }
                currentJudiciaryProccessId={props.currentJudiciaryProccessId}
                requestGetDahirAmount={props.requestGetDahirAmount}
                requestCreateCorporealRegulation={() => {}}
                requestGetRegulations={() => {}}
                regulations={[]}
                requestSagisClaimInfo={props.requestSagisClaimInfo}
                requestGetRegulation={() => {}}
                requestValidateRegulation={() => {}}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              />
            )}
          </GlobalLegalProceedingTabs>
        </SahamTabsGlobal>
      )}
    </Container>
  );
};

const mapDispatchToProps = {
  requestUpdateVictimInfo,
  requestClaimRecap,
  requestSearchClaims,
  getLegalProceedingsSteps,
  resetSearchClaimsStore,
  requestGetJudgementAdd,
  requestMakeJudgementAddDecision,
  requestGetExpertiseRaport,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestGetJudgementOnMerits,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  uploadDocument,
  resetUploadDocumentStore,
  requestGetJudgementAppeal,
  requestValidateJudgementAppeal,
  requestGetDahirAmount,
  setDocumentId,
  requestManagerFeeNotes,
  requestCreateFeeNote,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByClaimNumb,
  makeDecisionFeeNote,
  setCurrentInstanceTab,
  requestAllFeeNotes,
  requestCorporealLawyers,
  requestCreateCivilProceeding,
  requestGetCivilProceeding,
  requestGetJudgementAddAppeal,
  requestCreateJudgementOnMerits,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestSagisClaimInfo,
  requestGetDahirAmountCorpo,
  requestCreateJudgementOnMeritsContestation,
  requestMakeJudgementAddDocumentDecision,
  requestAssigment,
  requestAddVictims,
  updateContestation,
  requestUploadContestationDocument,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  requestAddVehicles,
  requestGetAppealOnMeritsMultiple,
  requestGetJudgementOnMeritsMultiple,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  requestGetExpertiseVictim,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestGetExpertUsers,
  requestUpdateFeeNoteAmount,
  requestCreateJudgementAdd,
  requestUpdateJudgementAdd,
  requestUpdateCivilProceeding,
  requestUnlockClaim,
  requestLockClaim,
  setLockedClaim,
  resetSagisInfoClaim,
  requestCheckCivilPartyJudiciaryProcess,
  resetStoreClaim,
  resetLegalProceeding,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
  requestGetClaimHistoryActions,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestResetHistoryStore,
  requestAddJudgementOnMeritsSupportDocument,
  requestCreateFeeNoteManager,
  requestSetPriorityClaimProvision,
  requestGetFeeNotesTransaction,
  requestGetTransaction,
  requestAddTransaction,
  resetStoreTransaction,
  requestUpdateTransaction,
  requestAddContactTransaction,
  requestGetContactTransaction,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
  requestUpdateContactTransaction,
  requestUpdateMissionTransaction,
  requestGetReportsPolicy,
  requestUploadDocumentManager,
  requestGetDocByDocumentumId,
  requestGetJudgements,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  policyInfo: makeSelectSearchClaims(),
  uploadedDocument: makeSelectDocument(),
  judgementAdd: makeSelectJudgementAdd(),
  currentSteps: makeSelectLegalProceedingsSteps(),
  expertiseReport: makeSelectExpertiseRaport(),
  judgementAddAppeal: makeSelectJudgementAddAppeal(),
  expertiseRaportAppeal: makeSelectExpertiseRaportAppeal(),
  judgementOnMerits: makeSelectJudgementOnMerits(),
  judgementOnMeritsAppeal: makeSelectJudgementOnMeritsAppeal(),
  judgementAppeal: makeSelectJudgementAppeal(),
  dahirAmount: makeSelectDahirAmounts(),
  documentId: makeSelectDocumentId(),
  feeNotes: makeSelectFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  keyclokToken: makeSelectKeycloakToken(),
  currentTabInstance: makeSelectCurrentInstanceTab(),
  allFeeNote: makeSelectAllFeeNotes(),
  corporealLawyers: makeSelectCorporealLawyers(),
  civilProceeding: makeSelectCivilProceeding(),
  sagisClaim: makeSelectSagisClaim(),
  dahirAmountsCorpo: makeSelectDahirAmountsCorpo(),
  linkToBeneficiaryCodes: makeSelectLinkToBeneficiaryCodes(),
  judgementOnMeritsMultiple: makeSelectJudgementOnMeritsMultiple(),
  appealOnMeritsMultiple: makeSelectAppealOnMeritsMultiple(),
  judgementOnMeritsByVictims: makeSelectJudgementOnMeritsByVictims(),
  judgementOnMeritsByVehicles: makeSelectJudgementOnMeritsByVehicles(),
  searchQuery: makeSelectSearchQuery(),
  corporealExperts: makeSelectCorporealExperts(),
  selectedSearchResult: makeSelectResultSearchQuery(),
  expertExpertise: makeSelectVictimExpertise(),
  loaders: selectedLoader,
  currentIndexTabManager: makeSelectCurrentTabManager(),
  currentGlobalTabManagerIndex: makeSelectGlobalCurrentTabManager(),
  currentJudiciaryProccessId: makeSelectCurrentTabJudiciaryProcessManager(),
  managerNotifcationsInboxes: makeSelectNotificationsInboxes(),
  claimHasCivilPartyJudiciaryProcess: makeSelectCheckCivilPartyJudiciaryProcess(),
  userActions: makeSelectClaimHistoryActions(),
  claimHistorySagis: makeSelectClaimHistorySagis(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CourtMonitoringManagerLegalProceedingsPage));
